import React__default from 'react';
import styled from 'styled-components';

const TouchLinkGroupItem = /*#__PURE__*/styled('li').withConfig({
  componentId: "sc-storm-ui-40026394__sc-13ge4n6-0"
})(["list-style:none;:not(:first-of-type):not(:last-of-type) > *{border-end-start-radius:0px;border-end-end-radius:0px;border-start-start-radius:0px;border-start-end-radius:0px;}:not(:only-of-type):first-of-type > *{border-end-start-radius:0px;border-end-end-radius:0px;}:not(:only-of-type):last-of-type > *{border-start-start-radius:0px;border-start-end-radius:0px;}:not(:only-of-type):not(:first-of-type) > *{border-block-start:none;}"]);
const StyledUl = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-storm-ui-40026394__sc-13ge4n6-1"
})(["list-style-type:none;margin-block-start:unset;margin-block-end:unset;margin-inline-start:unset;margin-inline-end:unset;padding-inline-start:unset;"]);
const TouchLinkGroup = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledUl, rest, children && React__default.Children.map(children, child => {
  if (! /*#__PURE__*/React__default.isValidElement(child)) return null;
  return /*#__PURE__*/React__default.createElement(TouchLinkGroupItem, null, /*#__PURE__*/React__default.cloneElement(child, {
    ...child.props
  }));
}));

export { TouchLinkGroup as T };
//# sourceMappingURL=TouchLinkGroup-BAQqUewJ.js.map
